<template>
  <div class="page">
    <div id="slider">
      <vueper-slides fade
                                   slide-content-outside-class="max-widthed"
                                   :touchable="true"
                                   :autoplay="true"
                                   fixed-height="100%"
                                   :bullets="true"
                                   :arrows="true"
                                   :pauseOnHover="false"
                                   speed="3500"
                                   transitionSpeed="1000"
                    >
                        <vueper-slide
                                v-for="(slide, i) in slides"
                                :key="i"
                                :image="slide.acf.slider"
                                class="slides"
                                :link="'/work/'+slide.acf.link"
                        ></vueper-slide>
                    </vueper-slides>
    </div>
    <div id="works">
      
      <div
        v-for="(work,i) in works"
        :key="i"
        class="work"
        v-lazy:background-image="work.acf.bgImg"
       
      >
        <router-link
          :key="i"
          :title="work.title.rendered"
          :to="{ name:'work', params: { name: work.id }}"
        >
        <div class="inner">
          <h3>{{ work.title.rendered }}</h3>
          <p v-html="work.acf.cover_intro"></p>
          </div>
        </router-link>
      </div>

    </div>
     <div class="copyright">
      Copyright 2020 北京洛琦科技有限公司. All Rights Reserved. 备案号: 京ICP备18030985号
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import {VueperSlide, VueperSlides} from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
export default {
  name: 'Home',

        components: {
            VueperSlides, VueperSlide,
        },
  data () {
    return {
      currentPage: 1,
      works: [
        {
          title: 'helo',
          id: 123,
          acf:{
            bgImg:'',
            cover_intro:''
          }
        },

      ],
      active:false,
            slides: [
                {
                    acf:{
                      slider:''
                    }
                }
            ],
    }
  },
  mounted () {
    this.axios
      .get('https://api.rocidesign.com/wp-json/wp/v2/projects?per_page=100')
      .then((response) => {
        this.works = response.data
      })
    this.axios
      .get('https://api.rocidesign.com/wp-json/wp/v2/slides')
      .then((response) => {
        this.slides = response.data
      })
  }
}
</script>
